module.exports = __webpack_public_path__ + "static/media/testfile_segmentAnything.03105a01.zip";